import styled, { css } from 'styled-components'
import { MEDIA } from 'utils/constants'
import { Card as FormCard } from 'components/forms'
import { Container as RadioContainer } from 'components/forms/radio'

import { assetPrefix } from 'config/env_config'

// Media query
const { DESKTOP_UP, MOBILE } = MEDIA

export const ServiceCard = styled(FormCard)`
  max-width: unset;

  @media screen and ${DESKTOP_UP} {
    width: 152px;
    min-height: 186px;
    padding: 16px 16px 27px;

    > div {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: flex-start;
      height: 100%;
    }
  }
`

export const Pet = styled(FormCard)`
  @media screen and ${DESKTOP_UP} {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 328px;
  }

`

export const ActionArea = styled.div``

export const Container = styled.div`
  ${({ gap }) => css`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: 100%;
    gap: ${gap || 0};

    @media screen and (max-width: 1200px) {
      width: unset;
      gap: 16px;
    }
  `}
`

export const Counter = styled.div`
  text-align: end;
  font-family: var(--primary-font);
  font-size: 12px;
  font-weight: 400;
  color: var(--gray-7);
  margin-top: -4px;
  margin-right: 16px;
  line-height: normal;
`

export const PageContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  margin-top: 32px;

  @media screen and (max-width: 1040px) {
    padding: 0 16px;
  }
`

export const WrapperContainerAndTitle = styled.div`

  @media screen and (max-width: 860px) {
    padding: 0;
    width: 100%;
  }
`

export const AlignWrappers = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
  margin-bottom: 24px;

  @media screen and (max-width: 1200px) {
    padding: 0 16px;
  }
`

export const WrapperTitle = styled.div`
  font-family: var(--primary-font);
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  padding-top: 16px;
  color: var(--gray-2);

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
  `}

  ${({ hasSelectedPet }) => hasSelectedPet && css`
    @media screen and (max-width: 1200px) {
      display: none;
    }
  `}

`

export const WrapperElements = styled.div`
  display: flex;
  gap: 16px;
  justify-content: center;
  margin-top: 24px;
`

export const PetRegistration = styled.div`
  position: absolute;
  bottom: 10px;
  right: 10px;
  height: 40px;
  display: flex;
  align-items: center;
  padding-right: 16px;
  font-size: 1.8rem;
  line-height: 1.6rem;
  font-weight: 600;
  font-family: var(--font-family);
  color: var(--cobasi-blue-light-8);

  :before {
    content: url('${assetPrefix}/static/icons/plus.svg');
    width: 2.4rem;
    height: 2.4rem;
    margin-right: 8px;
  }

  :active {
    transition: 0.1s;
    opacity: 0.3;
  }

  :hover {
    transition: 0.3s;
    opacity: 0.8;
  }

  cursor: pointer;

  @media screen and (max-width: 1200px) {
    right: 50%;
    bottom: 36px;
    transform: translate(50%, 50%);
    width: 190px;
    padding: 0%;
  }
`

export const WrapperAdditionalServicesAndObs = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

export const Card = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  border: 1px solid var(--silver);
  border-radius: 2.4rem;
  margin-bottom: 16px;
  padding:16px;
  width: 100%;
  position: relative;
  background: var(--the-white);
`
export const CardBody = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  position: relative;

  @media screen and (max-width: 1200px) {
    justify-content: flex-start;
    width: 100%;
  }
`

export const MessageGroup = styled.div`
  width: 100%;
  margin-top: 20px;
`

export const WrapperFormAndCard = styled.div`
  display: flex;
  width: 100%;
  max-width: 1100px;
  flex-direction: column-reverse;
  gap: 8px;
`

export const CardBodyInvertSteps = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  @media screen and ${MOBILE} {
    justify-content: space-between;
    align-items: center;
  }
`

export const CardContentInvertSteps = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  margin-bottom: 0px;
  align-items: center;

  h2 {
    font-family: var(--secondary-font);
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    line-height: 120%;
    letter-spacing: 0.96px;
    color: var(--gray-2);
  }

  p {
    font-family: var(--primary-font);
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 145%;
    color: var(--gray-5);
  }

  @media screen and ${MOBILE} {
    width: 100%;
    justify-content: start;
  }

  @media screen and (max-width: 768px) {
    margin: 0;
  }
`

export const WrapperTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`

export const Tag = styled.div`
  height: 24px;
  width: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  padding: 0 12px;
  background-color: var(--neutral-gray);
  font-family: var(--primary-font);
  font-style: normal;
  font-weight: 600;
  font-size: 13px;
  line-height: 145%;
`

export const RadioButtonContent = styled.div`
  ${RadioContainer} {
    label {
      width: 20px;
      height: 20px;
      margin-left: 0px;
      padding: 0;
    }
  }
`

export const RadioCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid var(--silver);
  border-radius: 2.4rem;
  max-width: 25rem;
  padding: 16px;
  gap: 16px;
  align-items: center;
  width: 139px;
  ${props => props.hasBorder && 'border: 2px solid var(--cobasi-blue-light-9)'};

  label {
    color: var(-gray-2);
    font-family: var(--primary-font);
    font-size: 16px;
    font-weight: 600;
    line-height: 16.8px;
    white-space: nowrap;
  }

  div > label {
    margin-left: 4px;
  }
`

export const IconContainer = styled.div`
  width: 56px;
  height: 56px;
  border-radius: 99px;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--bleached-silk);
`
